import { render, staticRenderFns } from "./SiteNavigation.vue?vue&type=template&id=bfb28f0a&scoped=true&"
import script from "./SiteNavigation.vue?vue&type=script&lang=js&"
export * from "./SiteNavigation.vue?vue&type=script&lang=js&"
import style0 from "./SiteNavigation.vue?vue&type=style&index=0&id=bfb28f0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb28f0a",
  null
  
)

export default component.exports